module.exports = __webpack_public_path__ + "static/img/datestatic_plat.b403ebc1.png";